import type { ProgramEvent, ProgramEventListType } from 'models';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTimeInfo, Space, Text, TimeLineIcon } from 'ui';
import { useGetEventTimeInfo } from '../../../hooks';
import type { EventListItemType } from '../EventListItem';

type P = {
  agendaTimeDisplay?: EventListItemType['agendaTimeDisplay'];
  endTime: ProgramEvent['endTime'];
  eventType: ProgramEventListType;
  isAllDay?: boolean;
  startTime: ProgramEvent['startTime'];
  status: ProgramEvent['status'];
};

export const useGetEventTimeContent = ({
  agendaTimeDisplay,
  endTime,
  eventType,
  isAllDay,
  startTime,
  status,
}: P): ReactNode => {
  const { t } = useTranslation();
  const getTimeInfo = useGetEventTimeInfo();
  const isCanceled = status === 'canceled';

  if (isAllDay === true || agendaTimeDisplay === 'allDay') {
    return (
      <Space size="xxs">
        <TimeLineIcon size="extra-small" type="dark-default" />
        <Text delete={isCanceled}>All day</Text>
      </Space>
    );
  }

  if (agendaTimeDisplay === 'endTime') {
    return (
      <Space size="xxs">
        <TimeLineIcon size="extra-small" type="dark-default" />
        <Text delete={isCanceled}>{t('Until {{ date, time }}', { date: endTime })}</Text>
      </Space>
    );
  }

  return (
    <DateTimeInfo
      display={{ date: false }}
      isStrikeThrough={isCanceled}
      timeInfo={
        agendaTimeDisplay === 'startTime'
          ? { dateTime: startTime }
          : getTimeInfo({ event: { endTime, startTime, type: eventType } })
      }
    />
  );
};
